import { useQuery } from '@tanstack/react-query';

import { api } from './api';
import { jetonCourant } from './jeton';

export const CLES = {
  moi: ['moi'],
  aujourdhui: ['aujourdhui'],
  historique: ['historique'],
  regles: ['regles'],
} as const;

export function useMoi() {
  return useQuery({ queryKey: CLES.moi, queryFn: api.moi, enabled: jetonCourant() !== null });
}

export function useAujourdhui(actif = true) {
  return useQuery({
    queryKey: CLES.aujourdhui,
    queryFn: api.aujourdhui,
    enabled: actif && jetonCourant() !== null,
    // L'écran du jour reste juste si l'appli reste ouverte (relances, heure qui passe).
    refetchInterval: 60_000,
    staleTime: 15_000,
  });
}

export function useHistorique(actif = true) {
  // Sans réglages (début de plaquette), l'API répond 409 : ne pas l'appeler.
  return useQuery({ queryKey: CLES.historique, queryFn: api.historique, enabled: actif });
}

export function useRegles() {
  return useQuery({ queryKey: CLES.regles, queryFn: api.regles, staleTime: Infinity });
}
